import { createFileRoute, redirect } from '@tanstack/react-router';
import { CommunityShell } from '../components/community/CommunityShell';
import { useAuthStore } from '../stores/auth.store';
import { useFeatures } from '../hooks/useFeatures';

export const Route = createFileRoute('/community')({
  component: CommunityLayout,
  beforeLoad: () => {
    const user = useAuthStore.getState().user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
});

function CommunityLayout() {
  const { isCommunityEnabled } = useFeatures();

  if (!isCommunityEnabled) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Funcionalidade Desativada</h1>
          <p className="text-gray-600">A funcionalidade de Comunidade está temporariamente desativada.</p>
        </div>
      </div>
    );
  }

  return <CommunityShell />;
}
